@switch (groupHtml()?.configType) {
<!-- MAIN -->
@case ('MAIN') {
<div class="my-2">
  <div class="d-flex justify-content-between align-items-center">
    @if (formGroupContextBase()) {
    <form class="pl-2" [formGroup]="formGroupContextBase()">
      <app-voucher-atp-inputs
        [type]="'contextName'"
        [label]="'contextName'"
        [formControlName]="'name'"
        [canModify]="canModify()"
      ></app-voucher-atp-inputs>
    </form>
    }
    <button mat-icon-button type="button" class="pb-3" color="warn" [disabled]="!canModify()" (click)="remove.emit()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
}
<!-- DOMAIN -->
@case ('DOMAIN') {
<div class="my-2 d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center">
    <h3 class="font-weight-bold">{{ 'DOMAIN' | titlecase }}:</h3>
    @if (formGroupContextBase()) {
    <form class="pl-2" [formGroup]="formGroupContextBase()">
      <app-voucher-atp-inputs
        [type]="'contextName'"
        [label]="'contextName'"
        [formControlName]="'name'"
        [canModify]="canModify()"
      ></app-voucher-atp-inputs>
    </form>
    }
  </div>
  <button mat-icon-button type="button" class="pb-3" color="warn" [disabled]="!canModify()" (click)="remove.emit()">
    <mat-icon>delete</mat-icon>
  </button>
</div>
}
<!-- DEFAULT -->
@default {
<div class="d-flex justify-content-between align-items-center py-2">
  <h3 class="m-0 font-weight-bold">
    {{ groupHtml().configType | titlecase }}
  </h3>
</div>
} }

<mat-divider class="mb-4"></mat-divider>
